import { makeStyles } from '@mui/styles';

const styles = makeStyles(({ breakpoints }) => ({
  wrapper: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    padding: '40px 6%',
    color: '#303030',
    borderTop: '5px solid #F1F1F0',

    [breakpoints.down('md')]: {
      padding: '50px 20px',
    },
  },

  wellboreImage: {
    width: '95%',
    display: 'block',
    margin: '0 auto',
    maxWidth: '835px',

    [breakpoints.down('md')]: {
      maxWidth: '400px'
    },
  },

  sectionTitle: {
    fontWeight: '700',
    marginTop: '48px',
    marginBottom: '24px',
    [breakpoints.down('md')]: {
      textAlign: 'center',
      marginTop: '0px',
    },
  },

  paragraph: {
    fontSize: '1.05rem',
    lineHeight: 1.9,
    marginBottom: '10px',

    [breakpoints.down('md')]: {
      fontSize: '1rem',
      lineHeight: 1.7,
      textAlign: 'center',
      marginBottom: '40px',
    },
  },

  chartContainer: {
    marginTop: '65px',
    [breakpoints.down('md')]: {
      width: '100vw',
      position: 'relative',
      left: '50%',
      marginLeft: '-50vw',
      marginTop: '0px',
    },
  },

  chartImage: {
    width: '100%',
    display: 'block',
  },

  link: {
    color: '#1b1b1b',
    fontWeight: 600,
    textDecoration: 'underline',
    transition: 'opacity .2s ease',

    '&:hover': {
      textDecoration: 'underline',
      opacity: 0.85,
    },
  },

  contentColumn: {
    display: 'flex',
    flexDirection: 'column',

    '@media (min-width: 1200px)': {
      justifyContent: 'space-between',
      height: '100%',
    },
  },

  textContent: {
    flex: 1,
  },
}));

export default styles;
